const breakPoints: { [key: string]: number } = {
  XXS: 350,
  XS: 400,
  SM: 500,
  MD: 768,
  LG: 1019,
  XL: 1200,
}
const minMq = (n: string) => {
  return `@media print, screen and (min-width: ${breakPoints[n] + 1}px)`
}

const maxMq = (n: string) => {
  return `@media screen and (max-width: ${breakPoints[n]}px)`
}

export {
  breakPoints,
  minMq,
  maxMq
}
